export const config = {
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL,
    publishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
    projectId: import.meta.env.VITE_SUPABASE_PROJECT_ID,
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    enabled: import.meta.env.PROD && !!import.meta.env.VITE_SENTRY_DSN,
  },
  analytics: {
    enabled: import.meta.env.PROD && !!import.meta.env.VITE_PLAUSIBLE_DOMAIN,
    domain: import.meta.env.VITE_PLAUSIBLE_DOMAIN,
  },
  app: {
    environment: import.meta.env.MODE as 'development' | 'staging' | 'production',
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
    baseUrl: import.meta.env.VITE_APP_URL || window.location.origin,
  },
  features: {
    enableDebugMode: import.meta.env.VITE_ENABLE_DEBUG_MODE === 'true',
    enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS !== 'false', // Enabled by default
  },
} as const;

export type Config = typeof config;
